<template>
  <div class="store-content">
    <van-radio-group v-model="storeRadio">
      <van-cell-group>
        <van-cell v-for="subItem in arr" :key="subItem.id" clickable @click="handleRadio(subItem)">
          <template #title>
            <van-radio shape="square" :name="subItem.id" style="pointer-events:none" />
          </template>
          <template #default>
            <div class="store-item-info" @click.stop="toDetail(subItem)">
              <div class="right-content">
                <img v-if="subItem.imgUrl" class="store-img" :src="subItem.imgUrl" alt="" @click.stop="imgPreview(subItem.imgUrl)">
                <img v-else class="store-img" src="@/assets/images/icon_noimg.png" alt="">
                <div class="customer-code">{{ subItem.sdCode }}</div>
              </div>
              <div class="right-section">
                <div class="store-name txt-ellipsis">{{ subItem.sdName }}</div>
                <div class="business-duty" v-if="subItem.dutyName || subItem.businessType">
                  <div class="business-type txt-ellipsis" v-if="subItem.businessType" :class="{'open-system': ['Open System', 'Open'].includes(subItem.businessType), 'tag2': ['Closed & Open System'].includes(subItem.businessType) }">{{ subItem.businessType }}</div>
                  <div v-if="subItem.dutyName" class="duty-name txt-ellipsis">{{ $t('shared.bA') }}：{{ subItem.dutyName }}</div>
                </div>
                <div class="product-type" v-if="subItem.newShelfList.length > 0">
                  <div class="type-info txt-ellipsis">
                    <span>({{ subItem.newShelfList.length }})</span>
                    <span>{{ subItem.newShelfList.join(',') }}</span>
                  </div>
                </div>
                <div class="last-activity" v-if="(subItem.lastOperationType || subItem.operationUserName || !['', null].includes(subItem.visitDifferDay))">
                  <span class="oper-type">{{ subItem.lastOperationType }}</span> <span v-if="subItem.operationUserName">{{ $t('shared.by') }} {{ subItem.operationUserName }}</span> <span v-if="!['', null].includes(subItem.visitDifferDay)"><span class="oper-time">{{ subItem.visitDifferDay | formatTime }}</span> <span v-show="subItem.visitDifferDay> 1">{{ $t('shared.daysAgo') }}</span></span>
                </div>
                <div class="basic-info">
                  <div v-if="subItem.city" class="city-name txt-ellipsis">{{ subItem.city }}</div>
                  <div class="type-distance">
                    <div class="distance">{{ subItem.distance | formatDistance }}</div>
                    <img v-if="subItem.lat" class="nav-path-img" src="@/assets/images/daohan1.png" alt="" @click.stop="routePlan(subItem)">
                  </div>
                </div>
              </div>
            </div>
          </template>
        </van-cell>
      </van-cell-group>
    </van-radio-group>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import i18n from '@/i18n'
export default {
  name: 'Store',
  props: {
    arr: {
      type: Array,
      required: true
    },
    pageType: {
      type: String,
      default: ''
    }
  },
  filters: {
    formatDistance (value) {
      if (value === null || value === undefined || value === '' || isNaN(value)) {
        return ''
      }
      const distance = Number(value)

      if (distance < 1) {
        return `<1${i18n.t('shared.metre')}`
      }
      if (distance < 100) {
        return Math.round(distance) + i18n.t('shared.metre')
      }
      if (distance > 1000000) { // > 1000km
        return `>1000${i18n.t('shared.kilometer')}`
      }
      // All remaining cases are between 100m and 1000km (inclusive)
      return (distance / 1000).toFixed(1) + i18n.t('shared.kilometer')
    },
    formatTime (val) {
      // return moment().diff(moment(val), 'days')
      return val === 0 ? i18n.t('shared.today') : val === 1 ? i18n.t('shared.yesterday') : val
    }
  },
  created () {},
  activated () {
    this.storeRadio = ''
  },
  data () {
    return {
      storeRadio: ''
    }
  },
  methods: {
    routePlan (params) {
      this.$emit('getCurrentLoc', params)
    },
    toDetail (item) {
      this.$router.push(`/salesDistribution/sdMappingDetail?customerId=${item.id}`)
    },
    imgPreview (url) {
      ImagePreview([url])
    },
    handleRadio (params) {
      if (this.storeRadio === params.id) {
        this.storeRadio = ''
      } else {
        this.storeRadio = params.id
      }
      this.$emit('getItemData', this.storeRadio ? params : { lat: '', lng: '' })
    }
  }
}
</script>

<style scoped lang="less">
.store-content {
  .img-bc {
    position: relative;
    width: 65px;
    height: 65px;
    padding: 9px;
    background: url('~@/assets/images/u91.png') no-repeat;
    background-size: 65px 65px;
  }
  /deep/.van-cell {
    padding: 10px;
    .van-cell__title {
      padding-top: 20px;
      flex: none;
    }
    .van-cell__value {
      padding-left: 10px;
      text-align: left;
      color: #000;
    }
  }
}
.store-item-info {
  display: flex;
  .right-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .customer-code {
      color: #7f7f7f;
      font-size: 8px;
      margin-top: 5px;
    }
  }
  .store-img {
    width: 62px;
    height: 62px;
    object-fit: cover;
  }
  .custom-img {
    position: absolute;
    width: 48px;
    height: 48px;
    object-fit: cover;
  }
  .right-section {
    flex: 1;
    line-height: 20px;
    margin-left: 10px;
    .store-name {
      max-width: 251px;
      font-size: 15px;
      font-weight: bold;
    }
    .business-duty {
      max-width: 251px;
      display: flex;
      font-size: 12px;
      margin-bottom: 3px;
      .business-type {
        max-width: 100px;
        padding: 3px;
        font-size: 10px;
        border: 1px solid #ee541b;
        color: #ee541b;
        background-color: #eccfc4;
        margin-right: 5px;
        line-height: 13px;
      }
      .open-system {
        border: 1px solid #0db00b;
        color: #0db00b;
        background-color: #abdaaa;
      }
      .tag2 {
        border: 1px solid #dc851f;
        color: #dc851f;
        background-color: #f0e2d1;
      }
      .duty-name {
        flex: 1;
      }
    }
    .product-type {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      font-size: 12px;
      .type-info {
        max-width: 251px;
        padding: 0px 3px;
        border: 1px solid #307bff;
        color: #307bff;
        border-radius: 3px;
      }
    }
    .last-activity {
      font-size: 12px;
      line-height: 14px;
      margin-bottom: 3px;
      .oper-type,
      .oper-time {
        color: #307bff;
        font-weight: bold;
      }
    }
    .basic-info {
      width: 253px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .type-distance {
        // flex: 1;
        display: flex;
        font-size: 12px;
        color: #7f7f7f;
      }
      .city-name {
        max-width: 100px;
        padding: 0px 2px;
        background-color: #9d6600;
        color: #fff;
        font-size: 10px;
        margin-right: 2px;
      }
      .address {
        flex: 1;
        font-size: 12px;
      }
      .nav-path-img {
        width: 18px;
        height: 18px;
      }
    }
  }
}
</style>
